module.exports = __webpack_public_path__ + "static/img/ikona_cw2-OFF.9bd3d817.png";